import React, { useState } from 'react';
import { goToCheckout } from '../utils/tracking';
export function GuaranteeSection() {
  return <section className="bg-navy px-5 py-20" data-id="element-1">
      <div className="mx-auto max-w-[900px]" data-id="element-2">
        <div className="grid grid-cols-1 items-center gap-10 rounded-[20px] border-2 border-gold/15 bg-slate p-[50px] md:grid-cols-[auto_1fr]" data-id="element-3">
          <div className="mx-auto flex h-[130px] w-[130px] shrink-0 flex-col items-center justify-center rounded-full bg-gradient-to-br from-gold to-[#FFA500] p-2.5 text-center text-[10px] font-black leading-[1.3] text-black shadow-[0_0_50px_rgba(255,215,0,0.25)] md:mx-0" data-id="element-4">
            <div className="text-[36px] font-black leading-none" data-id="element-5">7</div>
            DAY
            <br data-id="element-6" />
            MONEY BACK
            <br data-id="element-7" />
            GUARANTEE
          </div>
          <div className="text-center md:text-left" data-id="element-8">
            <h3 className="mb-4 text-[26px] font-black text-gold" data-id="element-9">
              The "Sharp as a Knife" Guarantee
            </h3>
            <p className="text-[15px] leading-[1.8] text-coolgray" data-id="element-10">
              Apply the 15-minute protocol for 7 days. If you don't experience a
              clear, undeniable lift in your mental clarity, afternoon energy,
              and daily productivity — I will refund every single penny. No
              questions. No forms. No runaround. You can keep the book and all 5
              bonuses as my thank-you for trying. The risk is 100% mine, not
              yours.
            </p>
          </div>
        </div>
      </div>
    </section>;
}
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    question: 'Do I need to buy expensive supplements or equipment?',
    answer: "No. 90% of the core protocol is built entirely on zero-cost biological factors: Sunlight, Cold Water, Breathing, and Timing. The Supplement Tier List bonus is there for those who want to go deeper — but it's absolutely optional."
  }, {
    question: "I'm extremely busy. Is this realistic for me?",
    answer: 'This was specifically built for the busiest professionals in America. The entire core protocol stack takes exactly 15 minutes. These are habits you "layer onto" what you already do — not a replacement for your morning.'
  }, {
    question: 'How fast will I see results?',
    answer: 'Most users report a noticeable shift in afternoon clarity within 48 hours of implementing just the Caffeine Delay and Morning Light protocols. The full 30-day plan delivers compounding results that most users describe as "life-changing."'
  }, {
    question: 'Is this a physical book or digital download?',
    answer: "Everything is 100% digital. After your purchase, you'll receive instant access to all 6 files in PDF format. You can read on any device — phone, tablet, or laptop — and start the protocol within minutes of buying."
  }, {
    question: "Why is it only $6.97? What's the catch?",
    answer: "There is no catch. My goal is to get this protocol in the hands of 10,000 high-performers this year. I'd rather prove this works at $6.97 and earn your long-term trust than overcharge you today. The 7-day guarantee means the risk is 100% mine."
  }, {
    question: "What if it doesn't work for me?",
    answer: "You're fully covered by the 7-Day \"Sharp as a Knife\" Guarantee. If you follow the protocol and don't see results, email us and you'll receive a full refund within 24 hours. No questions asked. You even keep all the bonuses."
  }];
  return <section className="bg-slate px-5 py-20" data-id="element-11">
      <div className="mx-auto max-w-[900px]" data-id="element-12">
        <p className="mb-4 text-center font-mono text-[11px] uppercase tracking-[3px] text-neon" data-id="element-13">
          // FREQUENTLY ASKED QUESTIONS
        </p>
        <h2 className="mb-4 text-center text-[clamp(26px,4vw,42px)] font-black leading-[1.2] text-offwhite" data-id="element-14">
          Got Questions? <span className="text-neon" data-id="element-15">We Have Answers.</span>
        </h2>

        <div className="mt-10 flex flex-col gap-3" data-id="element-16">
          {faqs.map((faq, index) => <div key={index} className={`overflow-hidden rounded-xl border bg-card transition-colors duration-200 ${openIndex === index ? 'border-neon/30' : 'border-neon/10'}`} data-id="element-17">
              <div className="flex cursor-pointer items-center justify-between px-6 py-5 text-[15px] font-bold transition-colors duration-200 hover:bg-neon/5" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-18">
                {faq.question}
                <span className={`shrink-0 text-[22px] text-neon transition-transform duration-200 ${openIndex === index ? 'rotate-45' : ''}`} data-id="element-19">
                  +
                </span>
              </div>
              {openIndex === index && <div className="px-6 pb-5 text-[14px] leading-[1.7] text-coolgray" data-id="element-20">
                  {faq.answer}
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}
export function FinalCta() {
  return <section className="bg-[radial-gradient(ellipse_at_center,rgba(0,255,65,0.1)_0%,transparent_70%),var(--navy)] bg-navy px-5 pb-[120px] pt-[100px] text-center" data-id="element-21">
      <div className="mx-auto max-w-[900px]" data-id="element-22">
        <p className="mb-4 text-center font-mono text-[11px] uppercase tracking-[3px] text-neon" data-id="element-23">
          // YOUR LAST CHANCE TODAY
        </p>
        <h2 className="mb-5 text-[clamp(30px,5vw,50px)] font-black leading-[1.2] text-offwhite" data-id="element-24">
          You Came Here For a Reason. <br data-id="element-25" />
          <span className="text-neon" data-id="element-26">Your Brain is Ready to Change.</span>
        </h2>
        <p className="mx-auto mb-10 max-w-[600px] text-[17px] leading-[1.7] text-coolgray" data-id="element-27">
          The 3:14 PM version of you — staring at the screen, exhausted,
          reaching for another coffee — doesn't have to be your story anymore.
          For less than a cup of coffee, you can start the protocol today.
        </p>

        <button onClick={e => {
        e.preventDefault();
        goToCheckout();
      }} className="mx-auto mb-4 block w-full max-w-[520px] cursor-pointer rounded-lg bg-gradient-to-br from-neon to-neon-dark px-10 py-[22px] text-center text-[19px] font-black text-black no-underline transition-all duration-300 hover:-translate-y-0.5 animate-pulse-glow border-none" data-id="element-28">
          ⚡ YES! DOWNLOAD THE COMPLETE BUNDLE FOR $6.97
        </button>

        <div className="mt-4 flex flex-wrap items-center justify-center gap-4 text-[12px] text-coolgray" data-id="element-29">
          <span data-id="element-30">🔒 Secure Checkout</span>
          <span data-id="element-31">⚡ Instant Access</span>
          <span data-id="element-32">✅ 7-Day Money-Back Guarantee</span>
        </div>
      </div>
    </section>;
}
export function Footer() {
  return <footer className="border-t border-white/5 bg-[#060F1E] px-5 py-10 text-center" data-id="element-33">
      <div className="mb-4 flex flex-wrap justify-center gap-7" data-id="element-34">
        <a href="#" className="text-[12px] text-coolgray no-underline transition-colors duration-200 hover:text-neon" data-id="element-35">
          Privacy Policy
        </a>
        <a href="#" className="text-[12px] text-coolgray no-underline transition-colors duration-200 hover:text-neon" data-id="element-36">
          Terms of Service
        </a>
        <a href="#" className="text-[12px] text-coolgray no-underline transition-colors duration-200 hover:text-neon" data-id="element-37">
          Contact Support
        </a>
        <a href="#" className="text-[12px] text-coolgray no-underline transition-colors duration-200 hover:text-neon" data-id="element-38">
          Earnings Disclaimer
        </a>
        <a href="#" className="text-[12px] text-coolgray no-underline transition-colors duration-200 hover:text-neon" data-id="element-39">
          Affiliates
        </a>
      </div>
      <p className="font-mono text-[11px] leading-[1.8] text-coolgray/40" data-id="element-40">
        © 2026 THE UNSTOPPABLE BRAIN. ALL RIGHTS RESERVED.
        <br data-id="element-41" />
        This product is for informational and educational purposes only.
        <br data-id="element-42" />
        Results may vary. Individual results are not guaranteed and may differ
        from person to person.
      </p>
      <p className="mx-auto mt-4 max-w-[700px] font-mono text-[10px] leading-[1.8] text-coolgray/30" data-id="element-43">
        This site is not a part of the Facebook™ website or Facebook™ Inc.
        Additionally, this site is NOT endorsed by Facebook™ in any way.
        FACEBOOK™ is a trademark of FACEBOOK™, Inc. As stipulated by law, we
        can not and do not make any guarantees about your ability to get results
        or earn any money with our ideas, information, tools, or strategies. We
        just want to help by giving great content, direction, and strategies.
        What we can guarantee is your satisfaction with our training. We don't
        believe in get-rich-quick programs. We believe in hard work, adding
        value, and serving others. And that's what our programs are designed to
        help you do. As stated by law, we can not and do not make any guarantees
        about your own ability to get results or earn any money with our ideas,
        information, tools, or strategies. We are here to help you by giving
        great content, direction, and strategies that have worked for us and our
        students. Nothing on this page, any of our websites, or any of our
        content or curriculum is a promise or guarantee of results or future
        earnings, and we do not offer any legal, medical, tax, or other
        professional advice. Any financial numbers referenced here, or on any of
        our sites, are illustrative of concepts only and should not be
        considered average earnings, exact earnings, or promises for actual or
        future performance. Use caution and always consult your accountant,
        lawyer, or professional advisor before acting on this or any information
        related to a lifestyle change or your business or finances. You alone
        are responsible and accountable for your decisions, actions, and results
        in life, and by your registration here you agree not to attempt to hold
        us liable for your decisions, actions, or results, at any time, under
        any circumstance.
      </p>
    </footer>;
}